import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HIGH_CONTRAST } from "../constants/storage";
import { Cookie } from "../services/storage";
import { ApplicationState } from "../store";
import { actionSetHighContrast, actionSetTTSVoices } from "../store/actions/layout-actions";
import { LayoutState } from "../store/reducers/layout-reducer";
import { useCookie } from "./cookie-hooks";
import { useSpeechSynthesis } from "react-speech-kit";

export const useLayout = () => {
  const dispatch = useDispatch();
  const { isFCAllowed } = useCookie();
  
  const { voices } = useSpeechSynthesis();
  const layoutState = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );

  useEffect(() => {
    if (layoutState.isHighContrast) {
      document.documentElement.setAttribute("data-theme", "hc");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
  }, [layoutState.isHighContrast]);

  const setTheme = (isHc: boolean) => {
    dispatch(actionSetHighContrast(isHc));

    if (isFCAllowed) {
      Cookie.set(HIGH_CONTRAST, isHc.toString());
    }
  };

  useEffect(() => {
    if(voices.length > 0){
      dispatch(actionSetTTSVoices(voices));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voices])

  return {
    setTheme,
  };
};
